import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const SEND_TO = ['all', 'teacherOnly']
const STATE = ['draft', 'published']

export const schema = Joi.object().keys({
  "send_to": Joi.string().valid(SEND_TO).required(),
  "class_id_list": Joi.allow(''),
  "title": Joi.string().required(),
  "content": Joi.string().required(),
  "state": Joi.string().valid(STATE).required(),
});

export default function addAnnouncement(schoolId, announcementInfo) {

  if(!schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school Id')
      })
    })
  }

  let validateResult = Joi.validate(announcementInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...announcementInfo,
    send_to: SEND_TO.indexOf(announcementInfo.send_to),
    state: STATE.indexOf(announcementInfo.state)
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/create_announcement/${schoolId}/`,
		'method': 'POST',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/announcement/addAnnouncement.js